import { ApiService } from '../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class GeographyMasterService {
    constructor(private apiService: ApiService) {
    }
    GetCountryList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/CountryMaster?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetRegionList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/RegionMaster?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetStateList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/StateMaster?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }


    GetCityList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/CityMaster?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetAreaList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/AreaMaster?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }



    GetPinCodeAreaMapping(str) {
        return this.apiService.get('ENSourceParas/api/mvp/search/PinAreaCodeMapping?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }


    GetDepartmentList(str) {
        return this.apiService.post('ENSourceParas/api/mvp/department/webSearch/' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GeneratedAcronym(str) {
        return this.apiService.post('ENSourceParas/api/mvp/department/GenerateAcronym?DepartmentName=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetReportsTo(level, DepartmentId) {
        return this.apiService.get('ENSourceParas/api/mvp/Designation/Master/ReportsTo?Level=' + level + '&&DepartmentId=' + DepartmentId)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GenerateDepartmentCode(str) {
        return this.apiService.post('ENSourceParas/api/mvp/department/GenerateDepartmentCode?DepartmentName=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDepartmentTypes() {
        return this.apiService.get('ENSourceParas/api/mvp/department/GetDepartmentType')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDepartments() {
        return this.apiService.get('ENSourceParas/api/mvp/department/GetDepartments')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDesignationTypes() {
        return this.apiService.get('ENSourceParas/api/mvp/Designation/Master/DesignationTypes')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDesignationLevels() {
        return this.apiService.get('ENSourceParas/api/mvp/Designation/Master/GetLevels')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDocumentTypes() {
        return this.apiService.get('ENSourceParas/api/mvp/DocumentType/weblist')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDesignationList(str) {
        return this.apiService.post('ENSourceParas/api/mvp/Designation/Master/search?search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GenerateCode() {
        return this.apiService.get('ENSourceParas/api/mvp/Document/Master/GenerateCode')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetDocumentList(str) {
        return this.apiService.post('ENSourceParas/api/mvp/Document/Master/search?Search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetBranchList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/Branch/Search?Search=' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetPincodeList(str) {
        return this.apiService.get('ENSourceParas/api/mvp/get/PinCode' + str)
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    GetLanguageList() {
        return this.apiService.get('ENSourceParas/api/mvp/getLanguages')
            .map(
            data => {
                return data;
            }
            ).catch(
            (error: Response) => {
                return "error";
            }
            );
    }

    CreateCountry(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/CountryMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditCountry(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/edit/CountryMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateRegion(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/RegionMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditRegion(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/edit/RegionMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateState(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/StateMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditState(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/edit/StateMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateCity(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/CityMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditCity(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/edit/CityMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateArea(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/AreaMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditArea(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/edit/AreaMaster', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateBranch(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Branch/Create', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditBranch(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Branch/Edit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreatePinCode(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/create/PinAreaCodeMapping', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditPinCode(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Branch/Edit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateDepartment(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/department/webcreate', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditDepartment(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Document/Master/webedit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    CreateDesignation(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Designation/Master/webcreate', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditDesignation(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Designation/Master/webedit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }
    CreateDocument(obj) {
        return this.apiService.post('ENSourceParas/api/mvp/Document/Master/webcreate', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

    EditDocument(obj) {
        return this.apiService.put('ENSourceParas/api/mvp/department/webedit', obj)
            .map(
            data => {
                return "Success";
            }
            ).catch(
            (error: Response) => {
                return "e";
            }
            );
    }

}


// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/geography_master.service.ts